<template>
  <div id="app">
    <div class="page">
      <app-header v-if="hasLogin&&showHeaderAndSideBar&&meta.fullscreen!==true"></app-header>
      <side-bar v-if="hasLogin&&showHeaderAndSideBar&&meta.fullscreen!==true"></side-bar>
      <app-content>
        <router-view></router-view>
      </app-content>
    </div>
    <call-dialog ref="call"></call-dialog>
  </div>
</template>
<style lang="scss">
@import "./common/styles/main";
</style>
<script>
/* eslint-disable no-undef */
import SideBar from "./common/components/Sidebar";
import AppHeader from "./common/components/Header";
import AppContent from "./common/components/Home";
import {DoPushEvent} from "./common/lib/pushevent";
import {tokenCache} from "./common/lib/cache/Token";
import {systemService} from "./common/lib/service/system";
import {EVENT_LOGIN_SUCCESS, EVENT_LOGOUT_SUCCESS} from "./modules/account/events";
import {staffService} from "./modules/staff/service/staff";
import CallDialog from "./modules/staff/components/call-dialog";
import {loginInfoCache} from "./common/lib/cache/LoginInfo";

export default {
  name: "App",
  components: {CallDialog, AppContent, AppHeader, SideBar},
  data() {
    return {
      showHeaderAndSideBar: false
    }
  },
  created() {
    // eslint-disable-next-line no-undef
    this.socket = io(this.$env.socket_url);
    this.socket.on('connect', async () => {
      Log('connect ok');
      await this.login();
    });
    this.socket.on('reconnect', () => {
      Log('reconnect ok');
    });
    this.socket.on('pushevent', (data) => {
      if (typeof data === 'string') data = JSON.parse(data);
      Log('pushevent data', data.type, data);
      data.type === "EMERGENCY" && this.$refs.call.show(data);
      data.type === "EMERGENCY_E1" && this.showNotify(data);
      DoPushEvent(this.$store, data);
    });
    bus.$on(EVENT_LOGIN_SUCCESS, this.login);
    bus.$on(EVENT_LOGOUT_SUCCESS, this.logout)
  },
  mounted() {
    this.showHeaderAndSideBar = true;
  },
  watch: {
    $route() {
      this.loginInfo = loginInfoCache.get();
    }
  },
  methods: {
    showNotify(data) {
      const h = this.$createElement;
      this.notify = this.$notify({
        title: data.alertTitle,
        message: h('div', [
          h('p', {class: 'fs14'}, data.alertBody),
          /*h('p', {
              class: 'fs12 mt10 color_main pointer',
              on: {
                  click: () => this.toDetail(data)
              }
          }, '查看详情')*/
        ]),
        type: 'success',
        duration: 0
      })
    },
    async toDetail(data) {
      //this.notify.close();
      const {loginInfo} = this;
      const {initHosId} = await staffService.detail(data.id);
      let aspectUser;
      if (initHosId === loginInfo.hosId) {
        aspectUser = 'init';
      } else {
        aspectUser = 'accept';
      }
      if (data.type === 'EMERGENCY') {
        this.$router.push({
          path: '/staff/detail',
          query: {id: data.id, aspectUser, action: 'callhushi'}
        })
      } else if (data.type === 'EMERGENCY_E1') {
        this.$router.push({
          path: '/staff/detail',
          query: {id: data.id, aspectUser, t: new Date().getTime()}
        })
      }
    },
    async login() {
      const token = tokenCache.get();
      if (this.socket && this.socket.disconnected) return this.socket.open();
      if (token) await systemService.deviceid(this.socket.id);
    },
    logout() {
      if (this.socket) this.socket.close();
      Log('socket', this.socket);
    }
  },
}
</script>
